import { useEffect, useState } from "react"
import { NormalTableRow, SmallContentTableRow, SmallTextTableRow } from "../Settings"
import SliderCell, { ISliderCell, ISliderInterface } from "./SliderCell"
import TextCell from "./TextCell"
import { Skeleton, TableCell, styled } from "@mui/material"

const SkeletonSlider = styled(Skeleton)(() => ({
    width: "100%",
    height: "100%",
    minHeight: "78px"
}));

interface ISliderRow<T extends ISliderInterface | [ISliderInterface | undefined, ISliderInterface | undefined]> extends ISliderCell<T> {
    mobile?: boolean;
    textTitle: string;
    subtitle: string;
    moreInfo?: React.ReactNode
}

const SliderRow = <T extends ISliderInterface | [ISliderInterface | undefined, ISliderInterface | undefined]>(props: ISliderRow<T>): JSX.Element => {
    
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(props.option === undefined);
    }, [props.option]);

    const getSkeleton = () => (
        <TableCell colSpan={3} style={{ paddingLeft: 'inherit' }}>
            <SkeletonSlider animation="wave" variant="text" />
        </TableCell>
    );

    const getSlider = () => (
        <SliderCell
            title={props.title}
            option={props.option}
            defaultOption={props.defaultOption}
            setOption={props.setOption}
            valueLabel={props.valueLabel}
            minValue={props.minValue}
            maxValue={props.maxValue}
            lockMaxValue={props.lockMaxValue}
            lockMinValue={props.lockMinValue}
            type={props.type}
            active={props.active}
            info={props.info}
            colspan={3}
            steps={props.steps}
            basic={props.basic}
            noWarningMsg={props.noWarningMsg}
            alwaysWarningMsg={props.alwaysWarningMsg}
            badValueRange={props.badValueRange}
            dontShowWarningMsg={props.dontShowWarningMsg}
            lockFirstArrayNumber={props.lockFirstArrayNumber}
            triggerOnFirstArrayValueChange={props.triggerOnFirstArrayValueChange}
        />
    );

    return (
        props.mobile?
            <>
            <SmallTextTableRow>
                <TextCell colspan={3} title={props.textTitle} subtitle={props.subtitle} moreInfo={props.moreInfo}/>
            </SmallTextTableRow>
            <SmallContentTableRow>
                {loading? getSkeleton() : getSlider()}
            </SmallContentTableRow>
            </>
            :
            <NormalTableRow>
                <TextCell title={props.textTitle} subtitle={props.subtitle} moreInfo={props.moreInfo}/>
                {loading? getSkeleton() : getSlider()}
            </NormalTableRow>
        )
}

export default SliderRow